"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFetch = exports.UPLOAD_CANCELED = exports.createApolloClient = exports.setApolloClient = exports.getApolloClient = void 0;
const apollo_client_1 = require("apollo-client");
const apollo_link_http_1 = require("apollo-link-http");
const apollo_link_1 = require("apollo-link");
const lib_1 = require("apollo-upload-client/lib");
const localTimeLink_1 = __importDefault(require("./addons/localTimeLink"));
const hoaCodeLink_1 = __importDefault(require("./addons/hoaCodeLink"));
const isFile_1 = __importDefault(require("./utils/isFile"));
const cache_1 = __importDefault(require("./addons/cache"));
const uploadFetch_1 = require("./addons/uploadFetch");
Object.defineProperty(exports, "UPLOAD_CANCELED", {
  enumerable: true,
  get: function () {
    return uploadFetch_1.UPLOAD_CANCELED;
  }
});
Object.defineProperty(exports, "uploadFetch", {
  enumerable: true,
  get: function () {
    return uploadFetch_1.uploadFetch;
  }
});
let apolloClient;
function getApolloClient() {
  if (!apolloClient && process.env.NODE_ENV !== 'test') {
    throw new Error('There are no the initialized apollo client, use "createApolloClient"');
  }
  return apolloClient;
}
exports.getApolloClient = getApolloClient;
function setApolloClient(client) {
  if (process.env.NODE_ENV !== 'test') {
    throw new Error('You can change the apollo client instance only for test purpose, use "createApolloClient" instead');
  }
  apolloClient = client;
}
exports.setApolloClient = setApolloClient;
function createApolloClient(uri) {
  const httpLink = (0, apollo_link_http_1.createHttpLink)({
    uri,
    credentials: 'include'
  });
  const uploadLink = (0, lib_1.createUploadLink)({
    uri,
    credentials: 'include',
    fetch: uploadFetch_1.uploadFetch
  });
  const isUpload = ({
    variables
  }) => Object.values(variables).some(isFile_1.default);
  const separateUploadLink = apollo_link_1.ApolloLink.split(isUpload, uploadLink, httpLink);
  const links = [localTimeLink_1.default, hoaCodeLink_1.default, separateUploadLink];
  apolloClient = new apollo_client_1.ApolloClient({
    cache: cache_1.default,
    link: apollo_link_1.ApolloLink.from(links),
    ssrMode: false,
    connectToDevTools: process.env.NODE_ENV !== 'production',
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore'
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    }
  });
  return apolloClient;
}
exports.createApolloClient = createApolloClient;